import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 5a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1l0 -14","key":"svg-0"}],["path",{"d":"M14 8h-4v8h4","key":"svg-1"}],["path",{"d":"M14 12h-4","key":"svg-2"}]]

const IconExplicit = createReactComponent('outline', 'explicit', 'Explicit', __iconNode);

export default IconExplicit;